import { Component } from '@angular/core';

@Component({
  selector: 'app-mssidcverifyproposal',
  templateUrl: './mssidcverifyproposal.component.html',
  styleUrl: './mssidcverifyproposal.component.css'
})
export class MssidcverifyproposalComponent {

}
